import { ProposalOverviewViewModel } from 'bff';
import { TableHeaderConfig } from 'types/table/TableHeaderConfig.type';
import style from './proposal-overview.module.scss';
import clsx from 'clsx';

export const proposalOverviewHeaderData: TableHeaderConfig<ProposalOverviewViewModel>[] = [
  {
    label: '',
    className: clsx(style.headers, style.smallHeader)
  },
  {
    key: 'id',
    label: 'Proposal #',
    className: style.headers
  },
  {
    key: 'dateCreated',
    label: 'Created',
    className: style.headers
  },
  {
    label: 'Client name',
    // key: 'clientName', // TODO: disabled until BFF sorting works.
    className: style.headers
  },
  {
    label: 'Product name',
    // key: 'productName', // TODO: disabled until BFF sorting works.
    className: style.headers
  },
  {
    label: 'Proposal value',
    // key: 'sumOfInvestmentAmount', // TODO: disabled until BFF sorting works.
    className: style.headers,
    align: 'right'
  },
  {
    label: 'Currency',
    // key: 'currency', // TODO: disabled until BFF sorting works.
    className: clsx(style.headers, style.mediumHeader)
  },
  {
    label: 'Status',
    key: 'statusId',
    className: clsx(style.headers, style.statusColumn),
    align: 'right'
  },
  {
    label: 'Last opened',
    key: 'lastOpened',
    className: style.headers
  },
  {
    label: '',
    className: clsx(style.headers, style.smallHeader)
  }
];
